import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";

export const createProductFamily = {
  name: "createProductFamily" as const,
  input: z.object({ title: z.string().optional() }),

  output: z.object({
    productFamilyId: productFamilyIdFormat.schema,
    productId: productIdFormat.schema,
  }),
};
